import * as Yup from "yup";
import { validation, conditionalValidation } from "../../../utils/constants";

export const genderOptions = [
    { value: "male", name: "Male" },
    { value: "female", name: "Female" },
    { value: "other", name: "Other" },
];

export const designationOption = [
    { value: "nurse", name: "Nurse" },
    { value: "nursePractitioner", name: "Nurse Practitioner" },
    { value: "physician", name: "Physician" },
];

export const typeOptions = [
    { value: "Patient", name: "Patient" },
    // { value: "Related_Person", name: "Related Person" },
    { value: "Practitioner", name: "Practitioner" },
    // { value: "Device", name: "Device" },
    // { value: "Kiosk Device", name: "Kiosk Device" }
]
export const nameToVal = {
    "patients" : "Patient",
    "employees" : "Practitioner",
    "super-admin": "Super-Admin",
    "Api Account": "API",
    "devices": "Devices"
}
export const listTypeOptionsForAllOrgs = [
    { name: "All", value: "All" }, 
    { name: "Super-Admin", value: "Super-Admin" }
]

export const listTypeOptions = [
    { value: "All", name: "All" },
    { value: "Patient", name: "Patient" },
    { value: "RelatedPerson", name: "Related Person" },
    { value: "Practitioner", name: "Practitioner" },
    { value: "API Account", name: "API Account"},
    //{ value: "Device", name: "Device" },
]

export const createAccountOptions = [
    { value: true, name: "Yes" },
    { value: false, name: "No" },
]

export const activeOptions = [
    { value: true, name: "Active" },
    { value: false, name: "Inactive" },
]
export const activeNotOptionsDisabled = [
    { value: true, name: "Active" },
    { value: false, name: "Inactive", disabled: true },
]

export const FormikObjCreate = {
    initialValues: {
        related_to: "",
        first_name: "",
        last_name: "",
        date_of_birth: "",
        phone_number: "",
        ext: "",
        address: "",
        city: "",
        country: "",
        region: "",
        email: "",
        organization: "",
        gender: "",
        type: "",
        postalCode: "",
        role: "",
        create_account: "",
        countrylist: [],
        scopeOfPractice: [],
        relationship: "",
        general_practitioner: [],
        hcn: "",
        device_name: "",
        clinic_location: "",
        designation: "",
        license: "",
        qualification: "",
        home_phone_number: "",
        healthCardAuthority:"",
        agentId: "",
    },
}
export const FormikObjEdit = {
    initialValues: {
        first_name: "",
        last_name: "",
        date_of_birth: "",
        phone_number: "",
        ext: "",
        address: "",
        city: "",
        country: "",
        region: "",
        email: "",
        organization: "",
        gender: "",
        postalCode: "",
        role: "",
        countrylist: [], 
        scopeOfPractice: [],
        isPatient: false,
        userType: "",
        create_account: "",
        relationship: "",
        related_to: "",
        general_practitioner: [],
        excludedOrgIds: [],
        hcn: "",
    },
}
export const FormikEditDeviceObj = {
    initialValues: {
        id: "",
        email: "",
        organization: "",
        device_name: "",
        clinic_location: "",
    },
    validationSchema: Yup.object({
        id: conditionalValidation(
            Yup.string(),
            {
                validation
            }),
        email: conditionalValidation(
            Yup.string().email("Invalid email address").matches(/^$|^\S+.*/, "Only blankspaces is not valid."),
            {
                validation,
                label: "Email",
                mandatory: true
            }),
        organization: conditionalValidation(
            Yup.string().matches(/^$|^\S+.*/, "Only blankspaces is not valid."),
            {
                validation,
                label: "Organization",
                mandatory: true
            }),
        device_name: conditionalValidation(
            Yup.string().matches(/^$|^\S+.*/, "Only blankspaces is not valid."),
            {
                validation,
                label: "Device Name",
                mandatory: true
            }),
        clinic_location: conditionalValidation(
            Yup.string().matches(/^$|^\S+.*/, "Only blankspaces is not valid."),
            {
                validation,
                label: "Clinical Location",
                mandatory: true
            })
    }),
}
//relations List For Scope Of Country
export const relationsList = [
    {
        name: "Father",
        value: "FATHER",
    },
    {
        name: "Mother",
        value: "MOTHER",
    },
    {
        name: "Son",
        value: "SON",
    },
    {
        name: "Daughter",
        value: "DAUGHTER",
    },
    {
        name: "Brother",
        value: "BROTHER",
    },
    {
        name: "Sister",
        value: "SISTER",
    },
    {
        name: "Spouse/Partner",
        value: "SPOUSE_PARTNER",
    },
    {
        name: "Adult Child",
        value: "ADULT_CHILD",
    },
    {
        name: "Grandparent",
        value: "GRANDPARENT",
    },
    {
        name: "Relative",
        value: "RELATIVE",
    },
    {
        name: "Caretaker",
        value: "CARETAKER",
    },
]

export const createBasicFields = [
    [{
        size: "3",
        fieldType: "TextInput",
        keyField: "first_name",
        label: "First Name",
        placeholder: "First Name",
    },
    {
        size: "3",
        fieldType: "TextInput",
        keyField: "last_name",
        label: "Last Name",
        placeholder: "Last Name",
    },
    {
        fieldType: "ReactDatePicker",
        keyField: "date_of_birth",
        label: "Date of Birth",
        placeholder: "Select Date",
        hasValue: "date_of_birth",
        displayAge: true,
    },
    {
        fieldType: "SelectFiled",
        keyField: "gender",
        label: "Select Gender",
        options: genderOptions,
    },
    ],
    [
        {
            size: "12",
            fieldType: "TextInput",
            keyField: "address",
            label: "Address",
            placeholder: "Address",
        }
     ],
    [
    {
        size: "6",
        fieldType: "CountrySelect",
        keyField: "country",
        label: "Country",
    },
    {
        size: "6",
        fieldType: "RegionSelect",
        keyField: "region",
    }
],
[
    {
        size: "6",
        fieldType: "TextInput",
        keyField: "city",
        label: "City",
        placeholder: "City",
    },
    {
        size: "6",
        fieldType: "postalCode",
        keyField: "postalCode",
    }
]
]

export const createBasicFieldsAPI = [
[{
        size: "6",
        fieldType: "TextInput",
        keyField: "account_name",
        label: "Account Name",
        placeholder: "Account Name",
    },
    {  
        size: "6",
        fieldType: "TextInput",
        keyField: "email",
        label: "Email Address",
        disabled: false
    },
],
[{
    size: "3",
    fieldType: "TextInput",
    keyField: "client_code",
    label: "Client Code",
    placeholder: "Client Code",
}] 
]

export const editBasicFieldsAPI = [
[{
        size: "6",
        fieldType: "TextInput",
        keyField: "account_name",
        label: "Account Name",
        placeholder: "Account Name",
    },
    {  
        size: "6",
        fieldType: "TextInput",
        keyField: "email",
        label: "Email Address",
        disabled: true
    },
],
[{
    size: "3",
    fieldType: "TextInput",
    keyField: "client_code",
    label: "Client Code",
    placeholder: "Client Code",
}] 
]

export const createBasicFieldsPractionerTwo = [
    [
        {
            fieldType: "TextInput",
            keyField: "license",
            label: "License Number",
            placeholder: "License Number",
            hideRequired: true
        },
        
        {
            fieldType: "TextInput",
            keyField: "qualification",
            label: "College",
            placeholder: "College",
            hideRequired: true
        },
        {
            fieldType: "SelectFiled",
            keyField: "designation",
            label: "Designation",
            options: designationOption,
            hideRequired: true
        },
        ],
]

export const editBasicFieldsPractionner = [
    [{
        fieldType: "TextInput",
        keyField: "first_name",
        label: "First Name",
        placeholder: "First Name",
    },
    {
        fieldType: "TextInput",
        keyField: "last_name",
        label: "Last Name",
        placeholder: "Last Name",
    },
    {
        fieldType: "SelectFiled",
        keyField: "designation",
        label: "Designation",
        options: designationOption,
        required: false,
    },
    {
        fieldType: "TextInput",
        keyField: "qualification",
        label: "College",
        placeholder: "College",
        required: false
    }],
    [
        {
            fieldType: "TextInput",
            keyField: "license",
            label: "License Number",
            placeholder: "License Number",
            required: false,
        },
        {
            fieldType: "ReactDatePicker",
            keyField: "date_of_birth",
            label: "Date of Birth",
            placeholder: "Select Date",
            hasValue: "date_of_birth",
            displayAge: true,
        },
        {
            fieldType: "SelectFiled",
            keyField: "gender",
            label: "Select Gender",
            options: genderOptions,
        }],
    [{
        fieldType: "CountrySelect",
        keyField: "country",
        label: "Country",
    },
    {
        fieldType: "RegionSelect",
        keyField: "region",
    },
    {
        fieldType: "TextInput",
        keyField: "city",
        label: "City",
        placeholder: "City",
    }],
    [{
        fieldType: "TextInput",
        keyField: "address",
        label: "Address",
        placeholder: "Address",
    },
    {
        fieldType: "postalCode",
    }, {}],
    [
        {
            type: "phone",
            fieldType: "TextInput",
            keyField: "phone_number",
            label: "Work Phone Number",           
            placeholder: "Work Phone Number",
            required: false,
        },
        {
            fieldType: "TextInput",
            keyField: "ext",
            label: "Ext",
            placeholder: "Ext",
            required: false,
        },
        {
            type: "phone",
            fieldType: "TextInput",
            keyField: "home_phone_number",            
            label: "Home Phone Number",
            placeholder: "Home Phone Number",
            required: false,
        },
    ]
]
export const editBasicFieldsPractionerRowOne = [
    [{
        fieldType: "TextInput",
        keyField: "first_name",
        label: "First Name",
        placeholder: "First Name",
    },
    {
        fieldType: "TextInput",
        keyField: "last_name",
        label: "Last Name",
        placeholder: "Last Name",
    },
    ],
    
]

export const editBasicFieldsPractionerRowThree = [
    [
        {
            size: "12",
            fieldType: "TextInput",
            keyField: "address",
            label: "Address",
            placeholder: "Address",
        },
    ],
    [
        {
            size: "6",
            fieldType: "CountrySelect",
            keyField: "country",
            label: "Country",
        },
        {
            size: "6",
            fieldType: "RegionSelect",
            keyField: "region",
        },
    ],
    [
        {   
            size: "5",
            fieldType: "TextInput",
            keyField: "city",
            label: "City",
            placeholder: "City",
        },
        {
            size: "3",
            fieldType: "postalCode",
        },
        {
            size: "4",
            type: "phone",
            fieldType: "TextInput",
            keyField: "home_phone_number",            
            label: "Home Phone Number",
            placeholder: "Home Phone Number",
            hideRequired: true,
        },
    ],
    [
        {
            size:"4",
            type: "phone",
            fieldType: "TextInput",
            keyField: "phone_number",
            label: "Work Phone Number",           
            placeholder: "Work Phone Number",
            hideRequired: true,
            
        },
        {   
            size: "2",
            fieldType: "TextInput",
            keyField: "ext",
            label: "Ext",
            placeholder: "Ext",
            hideRequired: true,
        },
        {  
            size: "6",
            fieldType: "TextInput",
            keyField: "email",
            label: "Email Address",
            disabled: true
        }
        
    ],
    
]
export const editBasicFieldsPractionerRowEight =[
    [
        {
            fieldType: "TextInput",
            keyField: "license",
            label: "License Number",
            placeholder: "License Number",
            hideRequired: true
        },
        {
            fieldType: "TextInput",
            keyField: "qualification",
            label: "College",
            placeholder: "College",
            hideRequired: true,
        },
        {
            fieldType: "SelectFiled",
            keyField: "designation",
            label: "Designation",
            options: designationOption,
            hideRequired: true,
        }
    ]
]


export const editBasicFields = [
    [{
        fieldType: "TextInput",
        keyField: "first_name",
        label: "First Name",
        placeholder: "First Name",
    },
    {
        fieldType: "TextInput",
        keyField: "last_name",
        label: "Last Name",
        placeholder: "Last Name",
    }],
    [{
        fieldType: "ReactDatePicker",
        keyField: "date_of_birth",
        label: "Date of Birth",
        placeholder: "Select Date",
        hasValue: "date_of_birth",
        displayAge: true,
    },
    {
        fieldType: "SelectFiled",
        keyField: "gender",
        label: "Select Gender",
        options: genderOptions,
    },
    {
        size: "5",
        fieldType: "TextInput",
        keyField: "hcn",
        label: "Patient Identifier",
        placeholder: "Patient Identifier",
    }
    ],
    [
        {
            size: "12",
            fieldType: "TextInput",
            keyField: "address",
            label: "Address",
            placeholder: "Address",
        }
     ],
    [
    {
        size: "6",
        fieldType: "CountrySelect",
        keyField: "country",
        label: "Country",
    },
    {
        size: "6",
        fieldType: "RegionSelect",
        keyField: "region",
    }
],
[
    {
        size: "6",
        fieldType: "TextInput",
        keyField: "city",
        label: "City",
        placeholder: "City",
    },
    {
        size: "6",
        fieldType: "postalCode",
    }
],
    [
    {
        fieldType: "TextInput",
        keyField: "phone_number",
        type: "phone",
        label: "Phone Number",
        hideRequired : true
    },
    {   
        size: "2",
        fieldType: "TextInput",
        keyField: "ext",
        type: "ext",
        label: "Ext.",
        hideRequired : true
    },
    {
        size: "6",
        fieldType: "TextInput",
        keyField: "email",
        label: "Email Address",
        hideRequired : true,
        isReadOnly: true
    },
    ],
]